module.exports = __webpack_public_path__ + "fonts/iconfont.8b3b147.woff";